import styled from "styled-components";

const UnstyledAnchor = styled.a(({ theme }) => ({
  "&:hover": {
    color: `${theme.colors.darkBlue} !important`,
    textDecoration: "underline",
  },
  color: `${theme.colors.blue} !important`,
  fontWeight: "bold",
  textDecoration: "none",
}));

export default UnstyledAnchor;
